import React from 'react'
import { Grid, Typography } from '@mui/material'
import moment, { Moment } from 'moment'
import { CalendarTextField } from '@/shared/ui/date'
import { StartDateSectionProps } from './types'

const StartDateSection: React.FC<StartDateSectionProps> = ({
    startDate,
    setStartDate,
    submitting,
    isValidStartDate,
    getCurrentLocale,
    label,
    isDateTime = true,
}) => {
    const handleChange = (newDate: Moment | null) => {
        if (!newDate) {
            setStartDate(undefined)
            return
        }

        if (isValidStartDate(newDate)) {
            setStartDate(new Date(newDate.format()))
        }
    }

    return (
        <Grid container>
            <Grid size={{ xs: 12, sm: 2 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        mb: 0.5,
                        display: 'block',
                    }}
                >
                    {label}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 10 }}>
                <CalendarTextField
                    value={startDate}
                    onChange={handleChange}
                    locale={getCurrentLocale()}
                    disabled={submitting}
                    isDateTime={isDateTime}
                    shouldDisableDate={(day) => !isValidStartDate(day)}
                    getCalendarTimeSource={() => moment()}
                />
            </Grid>
        </Grid>
    )
}

export default StartDateSection
